/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleBrandAggregateData
 */
export interface GoogleSearchConsoleBrandAggregateData {
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandAggregateData
     */
    category?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleSearchConsoleBrandAggregateData
     */
    queryCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandAggregateData
     */
    clicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandAggregateData
     */
    impressions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandAggregateData
     */
    ctr?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandAggregateData
     */
    position?: string | null;
}

/**
 * Check if a given object implements the GoogleSearchConsoleBrandAggregateData interface.
 */
export function instanceOfGoogleSearchConsoleBrandAggregateData(value: object): value is GoogleSearchConsoleBrandAggregateData {
    return true;
}

export function GoogleSearchConsoleBrandAggregateDataFromJSON(json: any): GoogleSearchConsoleBrandAggregateData {
    return GoogleSearchConsoleBrandAggregateDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandAggregateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleBrandAggregateData {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'queryCount': json['queryCount'] == null ? undefined : json['queryCount'],
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'ctr': json['ctr'] == null ? undefined : json['ctr'],
        'position': json['position'] === undefined ? undefined : json['position'] === null ? null : json['position'],
    };
}

export function GoogleSearchConsoleBrandAggregateDataToJSON(json: any): GoogleSearchConsoleBrandAggregateData {
    return GoogleSearchConsoleBrandAggregateDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandAggregateDataToJSONTyped(value?: GoogleSearchConsoleBrandAggregateData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'queryCount': value['queryCount'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'ctr': value['ctr'],
        'position': value['position'],
    };
}

